/**
 * Application Routes Configuration
 * Centralized location for all route paths used throughout the application.
 */

export const AppRoutes = {
  root: "/",
  notFound: "*",

  thankYou: "/ThankYouSuccessMsg",
  comingSoon: "/ComingSoon",
  test: "/Test",
  logs: "/Logs",

  inbox: "/inbox",
  insureds: "/Insureds",
  correctedDocumentResubmission: "/CorrectedDocumentResubmission",
  document: "/Document",
  lateFilingForm: "/LateFilingForm",
  licenseMatrix: "/LicenseMatrix",
  fmFlagReview: "/FMFlagReview",
  newSubmission: "/NewSubmission",
  stateLogins: "/StateLogins",
  submissions: "/Submissions",
  transaction: "/Transaction",

  // authentication routes
  login: "/Login",
  resetPassword: "/resetPassword",
  forgotPassword: "/resetPassword/forgot",

  home: {
    base: "/home",
    diligentSearchLibrary: "/home/DiligentSearchLibrary",
    iWantTo: "/home/IWantTo",
    reportTag: "/home/ReportTag",
    requestSignature: "/home/RequestSignature",
    sendStampedDocument: "/home/SendStampedDocument",
  },

  admin: {
    base: "/Admin",
    users: "/Admin/Users",
    clientUsers: "/Admin/ClientUsers",
    carrierManagement: "/Admin/CarrierManagement",
    insuranceCompany: "/Admin/InsuranceCompany",
    lineOfBusiness: "/Admin/LineOfBusiness",
    filingSchedule: "/Admin/Filing-Schedule",
    policyFilingSchedule: "/Admin/Policy-Filing-Schedule",
    manualStateSubmissionSchedule: "/Admin/ManualStateSubmissionSchedule",
    submissionData: "/Admin/SubmissionData",
    editCASLaSubmissionData: "/Admin/EditCASLaSubmissionData",
    stateStampList: "/Admin/StateStampList",
    stateLogins: "/Admin/StateLogins",
    statesZeroFilingRule: "/Admin/StatesZeroFilingRule",
    taxesAndFees: "/Admin/TaxesAndFees",
    partnerTaxAndFees: "/Admin/PartnerTaxandFees",
    taxScheduleByJurisdiction: "/Admin/TaxScheduleByJurisdiction",
    reporting: "/Admin/Reporting",
    reportModule: "/Admin/ReportModule",
    sendClientPortalUpdate: "/Admin/SendClientPortalUpdate",
    addEditCustomerPolicyDetails: "/Admin/AddEditCustomerPolicyDetails",
  },

  billing: {
    monthEndBillingModule: "/Billing/MonthEndBillingModule",
    stateReportsBilling: "/Billing/StateReportsBilling",
  },

  client: {
    base: "/client",
    home: "/clienthome",
    clientUsers: "/Client/ClientUsers",
    stateReports: "/Client/StateReports",
    nonPremiumEndorsements: "/Client/NonPremiumEndorsements",
  },

  filingQueue: {
    base: "/FilingQueue",
    nonPremiumEndorsement: "/FilingQueue/NonPremiumEndorsement",
    removedQueue: "/FilingQueue/RemovedQueue",
  },
  reconciliationQueue: "/ReconciliationQueue",

  reporting: {
    base: "/Reporting",
    openTaxReport: "/Reporting/OpenTaxReport",
    stateReport: "/Reporting/StateReport",
    yearToDate: "/Reporting/YearToDateReport",
    diligentSearch: "/Reporting/DiligentSearch",
    clientBillingReport: "/Reporting/ClientBillingReport",
    emailReportModule: "/Reporting/EmailReportModule",
    emailReportModuleDetails: "/Reporting/EmailReportModuleDetails",
  },
  customerOpenTaxReport: "/Customer/CustomerOpenTaxReport",

  partners: "/Partners",
  addEditPartners: "/AddEditPartners",
  userPartners: "/UserPartners",

  policy: "/Policy",
  policyDashboard: "/PolicyDashboard",
  policies: "/Policies",
  customer: "/Customer",
  customerPolicy: "/CustomerPolicy",
  createCustomerPolicy: "/CreateCustomerPolicy",
  customerPolicyDocumentData: "/CustomerPolicyDocumentData",
  addEditStateStamps: "/AddEditStateStamps",

} as const;

export type AppRouteKey = keyof typeof AppRoutes;
export type AppRouteValue = typeof AppRoutes[AppRouteKey];
